import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {MacroSurveyLoginView} from "../components/macroSurvey/MacroSurveyLoginView";

const MacroSurveyLogin: NextPage = () => {
  return <>
    <Head>
      <title>Login</title>
    </Head>
    <MacroSurveyLoginView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate', 'macro_survey']),
    }
  }
});

export default MacroSurveyLogin